var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-circle",style:({
    backgroundColor: _vm.colorHex,
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
    borderRadius: '50%',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }